import React from "react"
import { Modal, ModalFooter } from "react-bootstrap"

export const EditAlertModal = ({course, show, setShow}) => {

  return (
    <Modal show={show} onHide={() => setShow(false)} className="center-modal">
      <div className="courses-modal-title-container">
        <div className="courses-modal-title">
          {window.I18n.t('courses.master_roster_courses.edit_course')}
        </div>
      </div>
      <Modal.Body className='add-margin-bottom-10 add-margin-top-10 courses-small-modal-body-container'>
        {
          window.I18n.t('courses.master_roster_courses.edit_course_info')
        }
      </Modal.Body>
      <ModalFooter>
        <div className="courses-modal-buttons-container">
          <button onClick={() => setShow(false)} className="cancel_action small grey button btsp_small_white_button">{window.I18n.t('buttons.cancel')}</button>
          <div>
            <a href={course.copyEditUrl} className="next_action small orange button btsp_small_orange_button add-margin-right-5">
              {window.I18n.t('courses.bootstrap_courses.create_and_edit_copy')}
            </a>
            <a href={course.editUrl} className="next_action small orange button btsp_small_orange_button">
              {window.I18n.t('courses.bootstrap_courses.edit_this_course')}
            </a>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}